<template>
  <div
    class="certain-category-search-wrapper"
    v-click-outside="handleClickOutside"
  >
    <template v-if="isComponentMounted">
      <div class="aweme_list" @click.stop="toggleDropdown" ref="triggerEl">
        <div class="account-name">
          {{
            selectRes.advertiser_name ||
            (localDataSource[0] && localDataSource[0].advertiser_name)
          }}
        </div>
        <div class="auth-type-tag">官方</div>
        <a-icon
          type="down"
          :class="['down', { 'down-active': isDropdownOpen }]"
        />
      </div>

      <transition name="dropdown">
        <div v-show="isDropdownOpen" class="custom-dropdown">
          <div class="search-header" @mousedown.stop @click.stop>
            <a-input
              ref="searchInput"
              v-model="searchText"
              placeholder="请输入户ID或户名称搜索"
              @input="onSearch"
              class="search-input"
              @click.stop
            >
              <a-icon slot="prefix" type="search" />
            </a-input>
            <a
              style="color: #194ce5"
              href="javascript:void(0);"
              @click.stop="goaccout()"
              >+ 新增授权</a
            >
          </div>

          <div class="dropdown-content">
            <template v-if="filteredDataSource.length > 0">
              <div
                v-for="opt in filteredDataSource"
                :key="opt.advertiser_id"
                class="select-aweme"
                @click.stop="changAweme(opt)"
              >
                <div class="aweme-right">
                  <div class="aweme-info">
                    <div class="aweme-name">{{ opt.advertiser_name }}</div>
                    <div class="official" v-if="opt.general_balance_valid">
                      余额：{{ opt.general_balance_valid || '-' }}
                    </div>
                  </div>
                  <div class="aweme-show-id" v-if="opt.advertiser_id">
                    千川户ID：{{ opt.advertiser_id }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="empty-state">
                <a-icon type="inbox" class="empty-icon" />
                <p class="empty-text">暂无匹配数据</p>
              </div>
            </template>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
export default {
  name: 'awemeList',
  props: {
    dataSource: {
      type: Array,
    },
    action: {
      type: String,
      default: '',
    },
    advertiser_id: {
      type: String,
      default: '',
    },
    is_cache: {
      type: String,
      default: '1',
    },
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  data() {
    return {
      searchText: '',
      selectRes: {
        aweme_avatar: '',
        advertiser_name: '',
      },
      isDropdownOpen: false,
      isComponentMounted: false,
      isFirstLoad: true,
      isProcessing: false,
      localDataSource: [],
    };
  },

  components: {},

  watch: {
    dataSource: {
      immediate: true,
      handler(newVal) {
        this.localDataSource = JSON.parse(JSON.stringify(newVal || []));
      },
    },
    isDropdownOpen(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        });
      }
    },
  },

  created() {
    if (this.advertiser_id) {
      const storedId =
        localStorage.getItem('qc_advertiser_id') || this.advertiser_id;
      const selectRes =
        this.dataSource?.filter((item) => storedId == item.advertiser_id) || [];
      if (selectRes.length > 0) {
        this.selectRes.advertiser_name = selectRes[0].advertiser_name;
      }
    }
  },

  mounted() {
    setTimeout(() => {
      this.isComponentMounted = true;

      console.log('222', this.action);
      console.log('222', this.dataSource[0]);
      if (this.action == 'getVideoId') {
        this.getVideoData(this.dataSource[0]);
      }
      let advertiser_id = this.advertiser_id;
      console.log('投放户ID____________', advertiser_id);
      if (advertiser_id) {
        if (localStorage.getItem('qc_advertiser_id') && this.is_cache == '1') {
          advertiser_id = localStorage.getItem('qc_advertiser_id');
        }
        console.log('最后子组件接收到的', advertiser_id);
        console.log('缓存的', localStorage.getItem('qc_advertiser_id'));
        console.log('数组', this.dataSource);
        let selectRes = this.dataSource.filter(function (item) {
          return advertiser_id == item.advertiser_id;
        });
        if (selectRes.length > 0) {
          this.selectRes.advertiser_name = selectRes[0].advertiser_name;
          console.log('过滤后的', this.selectRes);
        }
      }
    });
  },
  methods: {
    getData(advertiser_id) {
      console.log('投放户ID', advertiser_id);
      if (advertiser_id) {
        let selectRes = this.localDataSource.filter(function (item) {
          return advertiser_id == item.advertiser_id;
        });
        if (selectRes.length > 0) {
          this.selectRes = {
            ...this.selectRes,
            advertiser_name: selectRes[0].advertiser_name,
          };
        }
        console.log('过滤后的', this.selectRes);
      }
      console.log('this.localDataSource', this.localDataSource);
    },
    goaccout() {
      this.$router.replace('/qc_account');
    },
    toggleDropdown() {
      if (this.isProcessing) return;
      this.isProcessing = true;

      this.isDropdownOpen = !this.isDropdownOpen;

      if (this.isDropdownOpen) {
        this.$nextTick(() => {
          this.$refs.searchInput && this.$refs.searchInput.focus();
          setTimeout(() => {
            this.isProcessing = false;
          }, 300);
        });
      } else {
        setTimeout(() => {
          this.isProcessing = false;
        }, 300);
      }
    },
    changAweme(e) {
      this.selectRes = e;
      this.$emit('getAdvertiserId', e.advertiser_id);
      this.isDropdownOpen = false;
      this.searchText = '';
    },
    onSearch() {
      // 不需要阻止事件，因为我们现在使用自定义下拉框
    },
    handleClickOutside() {
      if (this.isProcessing) return;
      this.isDropdownOpen = false;
      this.searchText = '';
    },
  },

  computed: {
    filteredDataSource() {
      if (!this.searchText || !this.localDataSource) {
        return this.localDataSource || [];
      }
      const searchLower = this.searchText.toString().toLowerCase();
      const filtered = this.localDataSource.filter(
        (item) =>
          (item.advertiser_id &&
            item.advertiser_id
              .toString()
              .toLowerCase()
              .includes(searchLower)) ||
          (item.advertiser_name &&
            item.advertiser_name.toString().toLowerCase().includes(searchLower))
      );
      return filtered;
    },
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="less" scoped>
.certain-category-search-wrapper {
  width: 350px;
  position: relative;
}
.aweme-right {
  padding: 0px 10px;
  text-align: left;
}
.select-aweme:hover {
  background-color: #e6f7ff;
}
.aweme_list {
  position: relative;
  width: 350px;
  height: 33px;
  display: flex;
  background-color: #f4f4f4;
  border-radius: 4px;
  align-items: center;
  padding-right: 26px;
  padding-left: 12px;
  cursor: pointer;

  .account-avatar {
    margin-right: 8px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }

  .account-name {
    overflow: hidden;
    flex: 1;
    font-size: 15px;
    margin-right: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    margin-left: 5px;
  }

  .auth-type-tag {
    color: #194ce5;
    background: #edf1fd;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 16px;
    height: 16px;
    font-size: 12px;
    padding: 0 4px;
    border-radius: 2px;
    font-weight: normal;
  }

  .down {
    position: absolute;
    top: 50%;
    right: 6px;
    margin-top: -7px;
  }
}

.select-aweme {
  cursor: pointer;
  border-radius: 4px;
  padding: 16px 8px;
  display: flex;
  align-items: center;

  .aweme-avatar {
    display: block;
    height: 32px;
    width: 32px;
    margin-right: 8px;
    border-radius: 50%;
  }

  .aweme-right {
    flex: 1;
  }
}

.aweme-name {
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  margin-right: 8px;
  width: 145px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}

.aweme-info {
  position: relative;
}

.official {
  position: absolute;
  color: #fa0909;
  background: #edf1fd;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 16px;
  height: 16px;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 2px;
  font-weight: normal;
  right: 0px;
  top: 10px;
}

.aweme-show-id {
  font-family: PingFang SC;
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color: #666;
}

.search-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;

  .search-input {
    width: 200px;
    margin-right: 8px;
  }
}

:deep(.ant-input-affix-wrapper) {
  .ant-input {
    font-size: 14px;
  }
  .ant-input-prefix {
    color: rgba(0, 0, 0, 0.45);
  }
}

:deep(.ant-select-dropdown) {
  z-index: 1050;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
  opacity: 1;
}

:deep(.ant-select-dropdown-hidden) {
  display: none;
}

.empty-state {
  padding: 24px;
  text-align: center;
  pointer-events: none;

  .empty-icon {
    font-size: 32px;
    color: #ccc;
    margin-bottom: 8px;
  }

  .empty-text {
    color: #999;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
  }
}

:deep(.ant-select-dropdown-menu-item-disabled) {
  cursor: default;
  color: inherit;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
}

.custom-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1050;
  margin-top: 4px;
}

.dropdown-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 0;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.3s, transform 0.3s;
  transform-origin: top;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: scaleY(0.8);
}
</style>
<style lang="less">
.certain-category-search-dropdown {
  .ant-select-dropdown-menu-item-group-title {
    height: 50px !important;
  }
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.ant-select-dropdown {
  animation-duration: 0.3s !important;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
</style>
